import React from 'react';
import styled from 'styled-components';
import media from '../../utils/media';
import Icon from './Icon';
import { ComponentHeader } from '../ComponentWrappers';
import { COMPONENT_MARGIN_BOTTOM } from '../../constants';
import { defineRegionFieldFromTitle, defineAriaLabelFromTitle } from '../../utils/helpers';
const Container = styled.div `
  outline: none;
  text-align: center;
  justify-content: center;
  align-items: center;
  max-width: 90%;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: ${`${COMPONENT_MARGIN_BOTTOM.DESKTOP}px`};
  ${media.smallDesktop} {
    max-width: 90%;
  }

  ${media.mobile} {
    margin-bottom: ${`${COMPONENT_MARGIN_BOTTOM.MOBILE}px`};
  }
  @media (max-width: 386px) {
    max-width: 100%;
    width: 100%;
  }
`;
const IconsContainer = styled.div `
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;
export const IconGrid = ({ fields }) => {
    if (!fields) {
        console.warn('IconGrid component requires fields to be provided');
        return null;
    }
    const { componentTitle, componentSubtitle, items, ariaLabel } = fields;
    const icons = items.map((icon, key) => {
        const { fields } = icon;
        return React.createElement(Icon, { key: key, fields: fields });
    });
    return (React.createElement(ComponentHeader, { title: componentTitle, subtitle: componentSubtitle, ariaLabel: ariaLabel },
        React.createElement(Container, { role: defineRegionFieldFromTitle(componentTitle), "aria-label": defineAriaLabelFromTitle(componentTitle, ariaLabel) },
            React.createElement(IconsContainer, null, icons))));
};
export default IconGrid;
